module.exports = __webpack_public_path__ + "img/TramInLeipzig.461227d8.svg";